import { Property } from "src/common";
import { ProductId } from "src/definitions";

export type SceneObjectData = {
	productId: ProductId;
	colorProperty: Property;
};

export const unitSystems = ["metric", "imperial"] as const;
export type UnitSystem = (typeof unitSystems)[number];
